import gql from 'graphql-tag';
import { cartFragment } from './sharedFragments';

export const CART_LINE_ITEMS_ADD_MUTATION = gql`
  mutation CartLineItemsAdd($cartId: ID!, $lines: [CartLineInput!]!) {
    cartLinesAdd(cartId: $cartId, lines: $lines) {
      userErrors {
        __typename
        code
        field
        message
      }
      cart {
        ...CartFragment
      }
    }
  }
  ${cartFragment}
`;
